(function($) {
    $(document).ready(function(){

        $('.hero-carousel').owlCarousel({
            loop:true,
            margin:0,
            merge:true,
            center:true,
            nav:true,
            lazyLoad: true,
            navText:['',''],
            responsiveClass:true,
            autoplay:true,
            autoplayTimeout:5000,
            autoplayHoverPause:true,
            responsive:{
                0:{
                    items:1
                }
            }
        });
        // There's a bug in owl carousel where the nav will stay hidden even when set to true.
        // Had to do a bit of a hack to get it to show.
        $('.hero-carousel').find('.owl-nav').removeClass('disabled');
        $('.hero-carousel').on('changed.owl.carousel', function(event) {
            $(this).find('.owl-nav').removeClass('disabled');
        });

        $("video[autoplay]").each(function(){ this.play(); });


    });
})(jQuery); // Fully reference jQuery after this point.
